import React from "react"
import {useNavigate} from "react-router-dom"
import {CssBaseline, MuiThemeProvider} from "@material-ui/core"
import {Security} from "@okta/okta-react"
import {OktaAuth, toRelativeUrl} from "@okta/okta-auth-js"

import {Pages} from "./Pages"
import {config} from "./config"

import {AgentProvider} from "@indebted/hooks/Agent"
import {NotificationProvider} from "@indebted/components/Notification"
import {theme} from "@indebted/theme"

const isEmbedded = () => {
	try {
		return window.self !== window.top
	} catch {
		return true
	}
}

const SecurityWrapper = ({children}: {children: React.ReactElement}) => {
	const navigate = useNavigate()

	if (isEmbedded()) {
		return children
	}

	const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
		navigate(toRelativeUrl(originalUri || "/", window.location.origin))
	}

	return (
		<Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
			{children}
		</Security>
	)
}

const oktaAuth = new OktaAuth(config.oktaAuth)

const App = () => {
	window.onbeforeunload = () => {
		localStorage.setItem("lastpage", `${window.location.pathname}${window.location.search}`)
		return null
	}

	return (
		<SecurityWrapper>
			<AgentProvider>
				<MuiThemeProvider theme={theme}>
					<CssBaseline />
					<NotificationProvider>
						<Pages />
					</NotificationProvider>
				</MuiThemeProvider>
			</AgentProvider>
		</SecurityWrapper>
	)
}

export {App}
